export default __webpack_public_path__ + "static/media/third-left-img.50c8610e.png";